// extracted by mini-css-extract-plugin
export default {"rating":"tB-z","numberOfStars":"uB-z","count":"vB-z","barGraphSpacing":"wB-z","barGraph":"xB-z"};